<div class="button-container" (click)="returnToTop()" *ngIf="showButton">
    <img class="returnTopButton white-filter" src="/assets/icons/chevron-up.png" alt="retour en haut de page" height="10">
</div>
